module.exports = __webpack_public_path__ + "688eb95104d272b7a43918c3de50a739.png";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader/dist/cjs.js!./assets/dorian.png
// module id = 96
// module chunks = 0